import React, { useState } from "react";
import Text from "../../Components/Text";
import { Link, useNavigate } from "react-router-dom";
import TextField1 from "../../Components/Textfield/TextField1";
import { medias } from "../../config/Resources";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import Image from "../../Components/Image";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import SocialAuth from "../SocialAuth";
import { useMutation, useQuery } from "@tanstack/react-query";
import axiosAdminInstance from "../../config/Axios/axiosAdminInstance";
import { API_URLS } from "../../config/API_URLS";
import { useFormik } from "formik";
import { RegisterSchema } from "../../config/Schema/LoginSignup";
import axiosInstance from "../../config/Axios/axiosInstance";
import { toast } from "react-toastify";
import { useUserInfoStore } from "../../store/userinfo";

type Props = {};

interface ResponseType {
  statusMessage?: string;
  // Add other properties based on the actual type of 'res'
}

const Register = (props: Props) => {
  const { setUserInfo, setIsLoggedin }: any = useUserInfoStore(
    (state) => state
  );
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      countryCode: "",
      mobile: "",
      password: "",
      firstName: "",
      lastName: "",
      middleName: "",
      country: null,
      state: null,
      city: null,
    },
    validationSchema: RegisterSchema,
    validateOnMount: false,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (value: any) => {
      (async () => {
        try {
          const res: any = await axiosInstance.post(API_URLS?.checkEmail, {
            email: value?.email,
          });

          console.log(res);

          if (res?.statusCode === 200) {
            axiosInstance
              .post(API_URLS.signup, {
                ...value,
                state: value.state.state,
                city: value.city.city,
                country: value.country.name,
                countryCode: "+91",
                mobile: "1234567890",
              })
              .then((res: any) => {
                if (res.statusCode === 200) {
                  toast("User registered successfully", {
                    type: "success",
                  });
                  const body = {
                    email: value.email,
                    password: value.password,
                  };
                  axiosInstance
                    .post(API_URLS.login, body)
                    .then((res: any) => {
                      if (res.result.token) {
                        localStorage.setItem(
                          "token-student",
                          res?.result?.token
                        );
                        toast("User LoggedIn successfully", {
                          type: "success",
                        });
                        setIsLoggedin(true);
                        navigate(
                          "/profile/career-counselling?location=psychometricTest"
                        );
                        formik.resetForm();
                      }
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                  formik.resetForm();
                }
              });
          } else {
            // console.log(res);
            toast(res?.statusMessage, {
              type: "error",
            });
          }
        } catch (error) {
          console.log(error);
          toast("SomeThing Went Wrong", {
            type: "error",
          });
        }
      })();
    },
  });

  const [VisibilityPassword, setVisibilityPassword] = useState(false);

  const {
    data,
    isLoading,
  }: {
    data: any;
    isLoading: boolean;
  } = useQuery({
    queryKey: ["fetch-state-county"],
    queryFn: () =>
      axiosAdminInstance
        .get(`${API_URLS.getAllDropdowns}?type=origin_country,state`)
        .then((res: any) => res?.result),
  });

  const { data: cityData, mutate: getCity } = useMutation({
    mutationFn: (state_id: string) =>
      axiosAdminInstance
        .get(`${API_URLS.getAllDropdowns}?type=city&state_id=${state_id}`)
        .then((res: any) => {
          return res?.result;
        }),
  });

  return (
    <div>
      <div className="flex justify-between ">
        <Text className="text-[24px] !font-[PlusJakartaSans-Bold] desktop:text-[18px]">
          Enter Register Details
        </Text>
        <Link
          to="/login-signup/login"
          className="text-[24px] !font-[PlusJakartaSans-Bold] desktop:text-[18px] text-[#2771E7] "
        >
          Login Here
        </Link>
      </div>
      <form
        autoComplete="false"
        onSubmit={formik.handleSubmit}
        className="w-full grid grid-cols-6 gap-[25px] miniDesk:gap-[15px] miniDesk:mt-[20px] mt-[32px]"
      >
        <div className="!w-full mob:!col-span-6 col-span-3 ">
          <TextField1
            id="firstName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="firstName"
            className="!w-full"
            value={formik.values.firstName}
            placeholder="First name"
            startAdornment={
              <InputAdornment position="start">
                <Image
                  className="mr-[20px] miniDesk:w-[14px]"
                  src={medias.images.inputIcons.firstNameIcon}
                />
              </InputAdornment>
            }
          />
          {formik.touched.firstName && (
            <Text className="text-[#dc143c]">{formik.errors.firstName}</Text>
          )}
        </div>
        <div className="!w-full mob:col-span-6 col-span-3">
          <TextField1
            id="middleName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.middleName}
            className="!w-full"
            name="middleName"
            placeholder="Middle name"
            startAdornment={
              <InputAdornment position="start">
                <Image
                  className="mr-[20px]  miniDesk:w-[14px]"
                  src={medias.images.inputIcons.firstNameIcon}
                />
              </InputAdornment>
            }
          />
          {formik.touched.middleName && (
            <Text className="text-[#dc143c]">{formik.errors.middleName}</Text>
          )}
        </div>
        <div className="!w-full miniDesk:col-span-6 col-span-6">
          <TextField1
            id="lastName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lastName}
            className="!w-full"
            name="lastName"
            placeholder="Last name"
            startAdornment={
              <InputAdornment position="start">
                <Image
                  className="mr-[20px]  miniDesk:w-[14px]"
                  src={medias.images.inputIcons.firstNameIcon}
                />
              </InputAdornment>
            }
          />
          {formik.touched.lastName && (
            <Text className="text-[#dc143c]">{formik.errors.lastName}</Text>
          )}
        </div>
        <div className="!w-full mob:col-span-6 col-span-3">
          <TextField1
            placeholder="Email ID"
            type="email"
            value={formik.values.email}
            className="!w-full"
            // id="email"
            autoComplete="off"
            role="presentation"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="email"
            startAdornment={
              <InputAdornment position="start">
                <Image
                  className="mr-[20px]  miniDesk:w-[14px]"
                  src={medias.images.inputIcons.EmailInputIcon}
                />
              </InputAdornment>
            }
          />

          {formik.touched.email && (
            <Text className="text-[#dc143c]">{formik.errors.email}</Text>
          )}
        </div>
        <div className="!w-full mob:col-span-6 col-span-3">
          <TextField1
            className="!w-full"
            placeholder="Password"
            role="presentation"
            autoComplete="new-passward"
            type={VisibilityPassword ? "text" : "password"}
            // id="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="password"
            startAdornment={
              <InputAdornment position="start">
                <Image
                  className="mr-[20px] miniDesk:w-[14px]"
                  src={medias.images.inputIcons.PasswordInputIcon}
                />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                {VisibilityPassword ? (
                  <Visibility
                    className="cursor-pointer"
                    onClick={() => setVisibilityPassword(false)}
                  />
                ) : (
                  <VisibilityOff
                    className="cursor-pointer"
                    onClick={() => setVisibilityPassword(true)}
                  />
                )}
              </InputAdornment>
            }
          />
          {formik.touched.password && (
            <Text className="text-[#dc143c]">{formik.errors.password}</Text>
          )}
        </div>
        <div className="!col-span-2 desktop:!col-span-6 w-full">
          <Autocomplete
            getOptionLabel={(option: any) => option?.name}
            options={data?.origin_country}
            disablePortal
            disableClearable
            className="!w-full !border rounded-xl"
            onBlur={formik.handleBlur}
            clearIcon={false}
            // value={formik.values.country}
            onChange={(event: any, newValue: string | null) => {
              formik.setFieldValue("country", newValue);
            }}
            // value={formik?.values?.country  ||  data?.origin_country ? data?.origin_country[0] : {}}

            loading={isLoading}
            renderInput={(params) => (
              <TextField
                name="country"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    input: "miniDesk:!text-[14px] miniDesk:!py-0",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Image
                        className="mr-[1px]  miniDesk:w-[14px]"
                        src={medias.images.inputIcons.countryIcon}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder={"County"}
              />
            )}
          />
          {/* <Select
                        displayEmpty
                        className='!w-full'
                        placeholder='County'
                        id="country"
                        value={formik.values.country}

                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="country"
                        startAdornment={
                            <InputAdornment position="start">
                                <Image src={medias.images.inputIcons.countryIcon} alt="country" />
                            </InputAdornment>
                        }
                        defaultValue={""}
                        classes={{
                            root: "!border !rounded-[14px] !border-[#70707037]",
                        }}
                        inputProps={{ 'aria-label': 'Without label', className: "w-full !outline-none !text-[17px] !placeholder:opacity-50 !placeholder:text-black" }}
                    >
                        <MenuItem value="" className='!hidden' selected hidden>
                            <em>County</em>
                        </MenuItem>
                        {
                            data?.origin_country?.map((items: any) => {
                                return <MenuItem key={items.id} value={items}>
                                    {items.name}
                                </MenuItem>

                            })
                        }

                    </Select> */}
          {formik.touched.country && (
            <Text className="text-[#dc143c]">{formik.errors.country}</Text>
          )}
        </div>
        <div className="!col-span-2 desktop:!col-span-3 mob:!col-span-6 w-full">
          <Autocomplete
            getOptionLabel={(option: any) => option?.state}
            options={data?.state}
            disablePortal
            className="!w-full !border rounded-xl"
            onBlur={formik.handleBlur}
            // value={formik.values.country}
            disableClearable
            value={formik?.values?.state}
            onChange={(event: any, newValue: any | null) => {
              formik.setFieldValue("state", null);
              getCity(newValue.state_id);
              formik.setFieldValue("state", newValue);
            }}
            loading={isLoading}
            renderInput={(params) => (
              <TextField
                name="state"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    input: "miniDesk:!text-[14px] miniDesk:!py-0",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Image
                        className="mr-[1px]  miniDesk:w-[14px]"
                        src={medias.images.inputIcons.stateIcon}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder={"State"}
              />
            )}
          />
          {/* <Select
                        displayEmpty
                        className='!w-full'
                        placeholder='State'
                        id="state"
                        value={formik.values.state}
                        onChange={(e: any) => { formik.handleChange(e) }}
                        onBlur={formik.handleBlur}
                        name="state"
                        startAdornment={
                            <InputAdornment position="start">
                                <Image src={medias.images.inputIcons.countryIcon} alt="country" />
                            </InputAdornment>
                        }
                        defaultValue={""}
                        classes={{
                            root: "!border !rounded-[14px] !border-[#70707037]",
                        }}
                        inputProps={{ 'aria-label': 'Without label', className: "w-full !outline-none !text-[17px] !placeholder:opacity-50 !placeholder:text-black" }}
                    >
                        <MenuItem value="" className='!hidden' selected hidden>
                            <em>State</em>
                        </MenuItem>
                        {
                            data?.state?.map((items: any) => {
                                return <MenuItem key={items.id} value={items}>
                                    {items.state}
                                </MenuItem>

                            })
                        }

                    </Select> */}
          {formik.touched.state && (
            <Text className="text-[#dc143c]">{formik.errors.state}</Text>
          )}
        </div>
        <div className="!col-span-2 desktop:!col-span-3 mob:!col-span-6 w-full">
          <Autocomplete
            getOptionLabel={(option: any) => option?.city}
            options={cityData?.city || []}
            disablePortal
            disableClearable
            disabled={!Boolean(formik.values.state)}
            className="!w-full !border rounded-xl"
            onBlur={formik.handleBlur}
            value={formik?.values?.city}
            // value={formik.values.country}
            onChange={(event: any, newValue: any | null) => {
              formik.setFieldValue("city", newValue);
            }}
            loading={isLoading}
            renderInput={(params) => (
              <TextField
                name="city"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    input: "miniDesk:!text-[14px] miniDesk:!py-0",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Image
                        className="mr-[1px]  miniDesk:w-[14px]"
                        src={medias.images.inputIcons.cityIcon}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder={"City"}
              />
            )}
          />
          {formik.touched.city && (
            <Text className="text-[#dc143c]">{formik.errors.city}</Text>
          )}
        </div>
        <Button
          type="submit"
          className="!text-[white] miniDesk:!py-[10px] !capitalize !text-[24px] miniDesk:!text-[16px] !col-span-6 !py-[18px] w-full !rounded-[13px]  !font-[600] !bg-[#239403]"
        >
          Register
        </Button>
      </form>
      {/* <div className='relative flex items-center my-[38px] justify-center w-full text-center'>
                <div className='h-[1px] absolute z-10 top-[50%] w-full bg-[#70707041]'></div>
                <Text className='relative z-20 px-2 text-[#00000048] font-semibold bg-[white] w-fit'>
                    OR
                </Text>

            </div>
            <div>
                <SocialAuth />
            </div> */}
    </div>
  );
};

export default Register;
